import { action } from 'mobx'

import AgencyResources from 'Services/AgencyResources'
import BaseStore from 'Stores/base_store/BaseStore'
import { getStoreFor } from 'Stores/StoreInstances'

export const STORE_TYPE = 'Ranks'

export function getRanksStoreFor (param, opts = {}) {
  return getStoreFor(RanksStore, STORE_TYPE, param, {
    forceUnique: false,
    preload: opts.preload,
    autoFetch: opts.autoFetch,
    fetchAll: opts.fetchAll,
  })
}

class RanksStore extends BaseStore {
  constructor (seedData) {
    const opts = {
      paginate: false,
    }
    super(STORE_TYPE, seedData, opts)
  }

  @action
  _fetchAll () {
    let payload = {
      ...this._filter,
    }
    return AgencyResources.requestResources(payload)
        .then(resources => resources.ranks)
        .catch(console.error)
  }
}

export default RanksStore
